import styled from 'styled-components'
import { BREAKPOINT_SM, CONTAINER_MAX_WIDTH } from '../../theme/ota'

interface FormCriteriaProps {
  searchEngine_orientation?: string
  centered?: boolean
}
interface ContainerGridProps {
  marginBottom?: string
}

export const ContainerCriteria = styled.div<FormCriteriaProps>`
  &&& {
    align-items: center !important;
    display: flex !important;
    justify-content: space-between !important;
    margin: ${({ centered }) => (centered ? '0 auto' : '0')} !important;
    @media (min-width: calc(${BREAKPOINT_SM})) {
      max-width: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '375px' : CONTAINER_MAX_WIDTH} !important;
    }
    width: 100% !important;

    & > form {
      display: flex !important;
      flex-grow: 1;
      justify-content: start !important;
      width: 100% !important;
      h3 {
        font-size: 16px !important;
        line-height: 27px !important;
      }

      @media (max-width: calc(${BREAKPOINT_SM})) {
        flex-direction: column !important;
        flex-wrap: wrap !important;
        align-self: stretch !important;
        display: block !important;
        font-size: 16px !important;
      }

      @media (min-width: calc(${BREAKPOINT_SM})) {
        flex-direction: ${({ searchEngine_orientation }) =>
          searchEngine_orientation === 'VERTICAL' ? 'column' : ''} !important;
      }
    }
  }
`

export const TitleInputs = styled.p`
  &&& {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    line-height: 17.76px;
  }
`

export const TitleRoom = styled.p`
  &&& {
    font-size: 14px !important;
    font-weight: 700 !important;
    line-height: 19.12px;
  }
`

export const BoxButton = styled.div<FormCriteriaProps>`
  &&& {
    @media (min-width: calc(${BREAKPOINT_SM})) {
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-end !important;
      margin-left: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '0' : '4px'} !important;
      margin-top: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '12px' : '0'} !important;
    }

    @media (max-width: ${BREAKPOINT_SM}) {
      margin-left: 0 !important;
    }
  }
`

export const TooltipContent = styled.span``

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
  ${TooltipContent} {
    width: 245px;
    white-space: pre-wrap;
    top: 28px;
    background-color: #273240;
    color: #fff;
    border-radius: 4px;
    line-height: 20px;
    text-align: left;
    right: 0px;
    padding: 10px;
    font-size: 14px !important;
    font-weight: lighter;
    z-index: 10;
    position: absolute;
    z-index: 1;
    &::after {
      bottom: 100%;
      right: 26px;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-bottom-color: #273240;
      border-width: 8px;
      margin-left: -65px;
    }
  }
`

export const BoxRoom = styled.div``

export const BoxOccupancy = styled.div`
  &&& {
    div.guest-count {
      align-items: center !important;
      display: flex !important;
      justify-content: space-between !important;
      margin-bottom: 15px !important;

      ${TitleInputs} {
        font-size: 14px !important;
        font-weight: 400 !important;
        margin-bottom: 0 !important;

        small {
          color: ${({ theme }) => theme?.colors?.gray5} !important;
          display: block !important;
          font-size: 11px !important;
        }
      }
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      padding-top: 20px !important;
      border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray4} !important;

      div.guest-count {
        ${TitleInputs} {
          font-size: 16px !important;
        }
      }
      div.border {
        border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray4} !important;
        padding-bottom: 20px !important;
      }
    }
  }
`

export const BtnPosition = styled.div`
  &&& {
    display: flex !important;
    justify-content: space-between !important;
    margin-top: 14px !important;
    min-width: 85px !important;
    padding-bottom: 1px !important;
    width: 100% !important;
  }
`

export const BoxDestination = styled.div<FormCriteriaProps>`
  &&& {
    @media (min-width: calc(${BREAKPOINT_SM})) {
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-end !important;
      flex-grow: 1 !important;
      min-width: 240px !important;
      margin: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '0' : '0 5px 0px 0px'} !important;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      margin-bottom: 26px !important;
      width: 100% !important;
    }
  }
`

export const BoxDates = styled.div<FormCriteriaProps>`
  &&& {
    @media (min-width: calc(${BREAKPOINT_SM})) {
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-end !important;
      margin: ${({ searchEngine_orientation }) => (searchEngine_orientation === 'VERTICAL' ? '0' : '0 5px')} !important;
      width: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '100%' : ' 310px'} !important;
      min-width: 250px;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      margin-bottom: 30px !important;
      width: 100% !important;
    }
  }
`

export const DateBaseStyles = styled.div`
  &&& {
    & + div {
      position: relative !important;
      left: 420px !important;
    }
  }
`

export const BoxRooms = styled.div<FormCriteriaProps>`
  &&& {
    @media (min-width: calc(${BREAKPOINT_SM})) {
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-end !important;
      margin: ${({ searchEngine_orientation }) => (searchEngine_orientation === 'VERTICAL' ? '0' : '0 5px')} !important;
      width: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '100%' : ' 210px'} !important;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      width: 100% !important;
      margin-bottom: 30px !important;
    }
  }
`

export const BoxCode = styled.div<FormCriteriaProps>`
  &&& {
    @media (min-width: calc(${BREAKPOINT_SM})) {
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-end !important;
      min-width: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '100%' : '160px'} !important;
      margin: ${({ searchEngine_orientation }) => (searchEngine_orientation === 'VERTICAL' ? '0' : '0 5px')} !important;
    }
    @media (max-width: calc(${BREAKPOINT_SM})) {
      width: 100% !important;
      margin-bottom: 20px !important;
    }
  }
`

export const BoxChildren = styled.div`
  &&& {
    display: flex !important;
    flex-wrap: wrap !important;
    margin-top: 30px !important;
    gap: 10px !important;
    margin-bottom: 20px !important;
    padding-left: 0 !important;

    div {
      flex: 1 !important;
      min-width: 85px !important;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      margin-bottom: 30px !important;
    }
  }
`

export const BoxClients = styled.div<FormCriteriaProps>`
  .MuiInputBase-root {
    padding: 2px !important;
    margin: 0 !important;
  }

  input {
    padding: 8px !important;
  }

  &&& {
    @media (min-width: calc(${BREAKPOINT_SM})) {
      display: flex !important;
      flex-direction: column !important;
      justify-content: flex-end !important;
      flex-grow: 1 !important;
      min-width: 240px !important;
      margin: ${({ searchEngine_orientation }) =>
        searchEngine_orientation === 'VERTICAL' ? '0' : '0 5px 0px 0px'} !important;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      margin-bottom: 26px !important;
      width: 100% !important;
    }
  }
`

export const HeaderClient = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
`

export const Container = styled.div`
  width: 100% !important;
`

export const ContainerHotelCriteria = styled.div<{ verticalOrientation?: boolean }>`
  & > form {
    margin: auto !important;
    height: 100%;
    width: fit-content !important;
  }
`

// ================================
export const ContainerGrid = styled.div<ContainerGridProps>`
  &&& {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;

    input {
      font-family: 'Manrope', sans-serif;
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      flex-wrap: wrap;
    }

    @media (min-width: calc(${BREAKPOINT_SM})) {
      & .toggle-person-field {
        max-width: 235px !important;
        min-height: 42px;
        display: flex;

        @media (max-width: calc(${BREAKPOINT_SM})) {
          min-width: auto;
        }
      }
      & .person-field {
        min-width: 250px;
        max-width: 275.5px !important;
      }
      & .occupancy-field {
        max-width: 210px !important;
      }
      & .client-field {
        max-width: 190px !important;
      }
      & .loyalty-option-field {
        max-width: 250px !important;
      }
    }
  }
`

export const Grid = styled.div<ContainerGridProps>`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    height: 92px;
    border: 1px solid ${({ theme }) => theme?.colors?.gray4};

    @media (max-width: calc(${BREAKPOINT_SM})) {
      border: none;
    }

    &:hover {
      background-color: ${({ theme }) => theme?.colors?.gray3};
    }

    &.destination-field {
      width: 350px !important;
      & ${TitleInputs} {
        padding: 0 20px;
      }

      @media (max-width: calc(${BREAKPOINT_SM})) {
        width: 100% !important;
        border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray4} !important;
      }
    }
    &.date-field {
      width: 250px !important;
      padding: 0 20px;

      @media (max-width: calc(${BREAKPOINT_SM})) {
        width: 100% !important;
        border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray4} !important;
      }

      & .datepicker-container,
      & .datepicker-container > button {
        height: 20px !important;
        background-color: transparent !important;
      }

      & button {
        /* background-color: transparent !important; */

        &.startStart,
        &.startEnd,
        &.endStart,
        &.endEnd {
          display: none !important;
        }
      }

      & .rdrCalendarWrapper.rdrDateRangeWrapper {
        background-color: transparent !important;
        font-family: 'Manrope', sans-serif !important;

        & .rdrDateDisplayWrapper {
          background-color: transparent !important;
        }

        & .rdrDateInput,
        & .rdrDateDisplayItem {
          text-align: left !important;
          height: 20px !important;

          & input {
            height: 20px !important;
          }
        }
        & .rdrDateDisplay {
          width: 180px !important;

          @media (max-width: calc(${BREAKPOINT_SM})) {
            width: 200px !important;
          }
        }

        & .rdrDateDisplayItem + .rdrDateDisplayItem::before {
          content: '';
          position: absolute;
          top: 10px;
          left: -5px;
          height: 1px;
          width: 5px;
          background-color: #000;
        }
      }
    }
    &.promocode-field {
      width: 250px !important;
      padding: 0 20px;

      @media (max-width: calc(${BREAKPOINT_SM})) {
        width: 100% !important;
      }

      & > div {
        height: 22px !important;
        display: flex !important;
        align-items: center !important;
      }

      & input {
        border: none !important;
        background-color: transparent !important;
        height: unset !important;

        &:focus,
        &:focus-visible,
        &:hover,
        &:active {
          border: none !important;
          outline: none !important;
        }
      }

      & div:has(svg) {
        top: 0 !important;
        left: 0 !important;

        & svg {
          width: 24px !important;
          height: 24px !important;
          color: ${({ theme }) => theme?.colors?.gray5} !important;
        }
      }
    }

    & div.destination-autocomplete {
      & img {
        width: 24px !important;
        height: 24px !important;
        margin-left: 20px !important;
        left: 0 !important;
        top: -2px !important;
      }
      & div:has(svg) {
        width: 24px !important;
        height: 24px !important;
        margin-right: 20px !important;
        right: 0 !important;
        top: -2px !important;
      }
    }

    & input.destination-autocomplete {
      border: none !important;
      background-color: transparent !important;
      padding: 0 20px 0 49px !important;
      height: auto !important;
      outline: none !important;
    }
  }
`

export const InputToggle = styled.div`
  &&& {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 218px;

    label {
      font-size: 12px;
      margin: 0;
      cursor: pointer;
    }
  }
`

export const OptionTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 4px;
`

export const LoyaltyLevelBadge = styled.div`
  padding: 2px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme?.colors?.gray4};
`

export const Text = styled.p`
  &&& {
    font-size: 12px;
    margin: 0;
  }
`

export const TextQuery = styled(Text)`
  &&& {
    color: ${({ theme }) => theme?.colors?.gray5};
  }
`

export const ButtonStyle = styled.div<ContainerGridProps>`
  &&& {
    align-items: flex-end;
    display: flex;
    width: 100% !important;

    & button {
      min-height: 92px !important;
      height: 92px !important;
      padding: 0 20px !important;
      border-radius: 0 !important;
    }

    /* Tooltip container */
    & .tooltip {
      position: relative;
      display: inline-block;
      border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
      .tooltiptext {
        width: 245px;
        white-space: pre-wrap;
        top: 28px;
        background-color: #273240;
        color: #fff;
        border-radius: 4px;
        line-height: 20px;
        text-align: left;
        right: 0px;
        padding: 10px;
        font-size: 14px !important;
        font-weight: lighter;
        z-index: 10;
        position: absolute;
        z-index: 1;
        &::after {
          bottom: 100%;
          right: 26px;
          border: solid transparent;
          content: '';
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
          border-bottom-color: #273240;
          border-width: 8px;
          margin-left: -65px;
        }
      }
    }

    @media (max-width: calc(${BREAKPOINT_SM})) {
      width: 100%;
    }
  }
`
export const RenderOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  &.align-right {
    align-items: flex-end;
  }
`

export const RenderNoOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
  padding: 10px;
`

export const RenderOptionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`

export const Link = styled.p`
  color: ${({ theme }) => theme?.colors?.info};
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    text-decoration: none;
  }
`

type ImageGroupProps = {
  src: string
}
export const ImageGroup = styled.img<ImageGroupProps>`
  src: ${({ src }) => `local(${src})`};
  width: 20px;
  height: 20px;
`

export const ButtonSearchCartStyleDiv = styled.div<{ verticalOrientation?: boolean }>`
  &&& {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 15px;
    width: ${({ verticalOrientation }) => (verticalOrientation ? '100% !important' : 'unset')};

    @media (max-width: calc(${BREAKPOINT_SM})) {
      width: 100%;
      margin-top: 18px;
    }
  }
`

export const ShoppingCartDropdown = styled.div``
